module.exports = __webpack_public_path__ + "static/media/ETKC1.9a4e8e7c.png";